var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');

var CrystalData = function(position, angle, init) {
    var self = this;
    DualRowPackageData.apply(this, arguments);

    //center gap between leads at opposite sides
    this.terminalGapMax = this.value("terminalGapMax", true);
    this.terminalGapMin = this.value("terminalGapMin", true);
    this.optionalDimension = this.value("optionalDimension", true);
    this.optionalCustomDimension = this.value("optionalCustomDimension", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalGapMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalGapMin);
    this.optionalDimension(ComponentAttribute.optionalDimensionInput["Optional_D"]);
    this.optionalCustomDimension(ComponentAttribute.optionalCustomDimensionInput["Optional_p"]);

    this.optionalDimension.onChange(this, function(value) {
        self.setupMinMaxPtrMap()
    });
};

lib_core.inherit(CrystalData, DualRowPackageData);
lib_core.JsonParser.registerClass(CrystalData, "CrystalData");

module.exports = CrystalData;

CrystalData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["terminalGap"] = [this.terminalGapMin, this.terminalGapMax];
    this.validationMap["terminalGapMax"] = [this.terminalGapMax];
    //remove input validate for optional dimension 
    if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_D"]) {
        delete this.validationMap["horizontalLeadToLeadSpanMax"]
        delete this.minMaxPointerMap["horizontalLeadToLeadSpan"]  
    } else if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_D2"]) {
        delete this.validationMap["terminalGapMax"]
        delete this.minMaxPointerMap["terminalGap"]
    } else if (this.optionalDimension() === ComponentAttribute.optionalDimensionInput["Optional_L"]) {
        delete this.validationMap["padWidthMax"]
        delete this.minMaxPointerMap["padWidth"]
    }  
};

CrystalData.prototype.getSilkscreen = function(pads) {
	var silkscreen = [];
    if(pads.length === 0) return silkscreen;

    var body = this.getBodyForSilkscreen();
    this.populateSilkscreenForBody(body, pads[0], pads[0], silkscreen);
    return silkscreen;
};